import { predict2D } from './utils/predict2D';
export async function predictHMBC(molecule, options) {
    const { minLength = 2, maxLength = 3, joinDistance = { H: 0.05, C: 0.5 }, } = options;
    return predict2D(molecule, {
        ...options,
        from: 'H',
        to: 'C',
        minLength,
        maxLength,
        joinDistance,
    });
}
//# sourceMappingURL=predictHMBC.js.map